if ('ontouchstart' in document.documentElement) {
  document.body.classList.add('TouchScreenDevice');
} else {
  document.body.classList.add('Desktop');
}
